import { DirectionEnum, yupLocalized } from "@ryde/shared";

/** Direction and time are mandatory; the date is the one field a run may leave alone. */
export const bulkUpdateBookingsDateTimeValidationSchema = {
  direction: yupLocalized
    .string()
    .oneOf([DirectionEnum.PickUp, DirectionEnum.DropOff])
    .required(),
  time: yupLocalized.string().required(),
  date: yupLocalized.date().nullable(),
};
